import { render, staticRenderFns } from "./ColorView.vue?vue&type=template&id=20086cc4&scoped=true"
import script from "./ColorView.vue?vue&type=script&lang=js"
export * from "./ColorView.vue?vue&type=script&lang=js"
import style0 from "./ColorView.vue?vue&type=style&index=0&id=20086cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20086cc4",
  null
  
)

export default component.exports